import type {ReduxState} from '@/redux'

export const availableGlobalCampaigns = (state: ReduxState) => state.globalCampaign.availableCampaigns;
export const selectedGlobalCampaign = (state: ReduxState) => state.globalCampaign.selectedCampaign;
export const globalCampaignIsPending = (state: ReduxState) => state.globalCampaign.isPending;
export const globalCampaignIsError = (state: ReduxState) => state.globalCampaign.isError;
